<template>
  <div class="order">
    <search
      :statusList="statusList"
      :status="defaultStatus"
      :recordsSearchObj="recordsSearchObj"
      :carTypeList="carTypeList"
      @handleSearch="handleSearch"
    />
    <div class="table-container">
      <div class="table-btn">
        <!-- :loading="exportLoading" -->
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport"
          >导出</el-button
        >
      </div>
      <!-- v-loading="loading" -->
      <el-table
        :data="tableData"
        highlight-current-row
        border
        stripe
        @filter-change="filterChange"
      >
        <el-table-column type="selection" width="40" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="claimStatementId"
          label="索赔单号"
          :min-width="$getColumnWidth('claimStatementId', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="claimStatementNum"
          label="订单号"
          :min-width="$getColumnWidth('claimStatementNum', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditResultDisplay"
          label="状态"
          :min-width="$getColumnWidth('auditResultDisplay', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerAccount"
          label="客户账号"
          :min-width="$getColumnWidth('customerAccount', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerClaimNumber"
          label="客户索赔单号"
          :min-width="$getColumnWidth('customerClaimNumber', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          :min-width="$getColumnWidth('customerName', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="country"
          label="国家"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.country }}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="faultPartNumber"
          label="故障件代码"
          :min-width="$getColumnWidth('faultPartNumber', tableData)"
        >
        </el-table-column>
        <el-table-column
          prop="faultPartName"
          label="故障件名称"
          :min-width="$getColumnWidth('faultPartName', tableData)"
        >
        </el-table-column>

        <el-table-column
          v-for="(item, index) in responsibilityPartListMaxLength"
          :key="index"
          :label="`责任方${numberToChinese(item)}`"
          show-overflow-tooltip
          align="center"
        >
          <el-table-column
            label="责任部门/供应商名称"
            :min-width="160"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? scope.row.responsibilityPartList[index]
                      .responsibilitySupplier ||
                    scope.row.responsibilityPartList[index]
                      .responsibilityDepartment
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="责任占比"
            :min-width="90"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? `${scope.row.responsibilityPartList[index].responsibilityRatio}%`
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="责任金额"
            :min-width="90"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? scope.row.responsibilityPartList[index].secondDamages
                    ? `¥${scope.row.responsibilityPartList[index].secondDamages}`
                    : "无"
                  : "无"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="happenDate"
          label="发生日期"
          :min-width="$getColumnWidth('happenDate', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="申请时间"
          :min-width="$getColumnWidth('createTime', tableData)"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="rejectNum"
          label="驳回次数"
          :min-width="$getColumnWidth('rejectNum', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditPassTime"
          label="正审时间"
          :min-width="$getColumnWidth('auditPassTime', tableData)"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="determineResponsibilityTime"
          label="判责时间"
          :min-width="$getColumnWidth('determineResponsibilityTime', tableData)"
          align="center"
        >
        </el-table-column> -->
        <el-table-column
          prop="settlementTime"
          label="结算时间"
          :min-width="$getColumnWidth('settlementTime', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="110px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="toDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="
                ((scope.row.status == 3 ||
                  scope.row.status == 16 ||
                  scope.row.status == 21) &&
                  hasAnyRole(['KD索赔经理', '索赔经理'])) ||
                  ((scope.row.status == 15 || scope.row.status == 18) &&
                    hasAnyRole(['OTS部部长'])) ||
                  (scope.row.status == 17 && hasAnyRole(['章总']))
              "
              size="mini"
              type="text"
              @click="handleAudit(scope.row, scope.$index)"
              >审核</el-button
            >
            <el-button
              v-if="scope.row.status == 4"
              size="mini"
              type="text"
              @click="handleRevocation(scope.row)"
              >撤回</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  climantList,
  formalAuditRejectRevocationApi,
  trialClimantExport
} from "@/api/kdsuopei";
import search from "./components/indexSearch";
import { getNations } from "@/util/getNation";
import { getSession, setStorage } from "@/util/localStor";
import { getDownloadFiles } from "@/util/downFile";
import { getDictItem } from "@/util/dict";
import { numberToChinese } from "@/util/index";
import { getCurrentRoles, hasAnyRole } from "@/utils/role";

export default {
  components: {
    search
  },
  data() {
    const { data, pageNum, pageSize } = this.$route?.query?.searchObj
      ? JSON.parse(this.$route?.query?.searchObj)
      : {};
    return {
      statusList: [
        { label: "全部", value: "3,4,5,19,21,11,12,13,14,15,16,17,18" },
        { label: "待正审", value: "3" },
        { label: "驳回（正审）", value: "4" },
        { label: "已拒赔", value: "5" },
        { label: "待确认（责任主体）", value: "19" },
        { label: "驳回（责任确定）", value: "21" },
        { label: "待结算", value: "11" },
        { label: "已结算", value: "12" },
        { label: "已取消", value: "13" },
        { label: "已撤回", value: "14" },
        { label: "待加签(部长)", value: "15" },
        { label: "已驳回(部长)", value: "16" },
        { label: "待加签(章总)", value: "17" },
        { label: "已驳回(章总)", value: "18" }
      ],
      searchInfo: {
        status: "3"
      },
      defaultStatus: "3", // 默认显示状态，用于重置
      // loading: false,
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      total: 0,
      // exportLoading: false,
      recordsSearchObj: data,
      countryList: [],
      searchData: {},
      carTypeList: [],
      role: "",
      userRoles: [],
      responsibilityPartListMaxLength: 0 // 责任方最大长度
    };
  },
  created() {
    this.userRoles = getCurrentRoles();
    this.role = this.userRoles[0] || sessionStorage.getItem("role") || "";
    if (hasAnyRole(["OTS部部长"])) {
      this.defaultStatus = "15";
    }
    if (hasAnyRole(["章总"])) {
      this.defaultStatus = "17";
    }
    this.searchInfo.status = this.defaultStatus;
  },
  async mounted() {
    this.searchInfo = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.searchInfo;
    delete this.searchInfo.auditPassTime;
    delete this.searchInfo.determineResponsibilityTime;
    delete this.searchInfo.happenTime;
    Object.values(getSession("nationList")).map(item => {
      if (item.id != 0) {
        this.countryList.push({ text: item.name, value: item.id });
      }
    });

    this.getList();
    // 获取车型
    const carTypeList = await getDictItem("carType");
    carTypeList.map(item => {
      this.carTypeList.push({ text: item.value, value: item.code });
    });
  },
  methods: {
    numberToChinese,
    hasAnyRole,
    // 获取国家
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    // 搜索
    handleSearch(data) {
      this.searchData = JSON.parse(JSON.stringify(data));
      let obj = data;
      this.searchInfo.lbjzy = obj.lbjzy;
      this.searchInfo.claimStatementNum = obj.claimStatementNum;
      this.searchInfo.claimStatementId = obj.claimStatementId;
      this.searchInfo.status = obj.status;
      this.searchInfo.customerAccount = obj.customerAccount;
      obj.countryId=='0'?this.searchInfo.country = '':this.searchInfo.country = obj.countryId
      this.searchInfo.responsibilitySupplierName = obj.responsibilitySupplierName;
      this.searchInfo.claimType = obj.claimType;
      this.searchInfo.faultPartNumber = obj.faultPartNumber;
      this.searchInfo.faultPartNameZh = obj.faultPartNameZh;
      this.searchInfo.responsibilityDepartment = obj.responsibilityDepartment;

      this.page = 1;
      this.pageSize = 10;
      if (data.date !== "" && data.date !== null) {
        this.searchInfo.preapprovalPassTimeStart = data.date[0] + " 00:00:00";
        this.searchInfo.preapprovalPassTimeEnd = data.date[1] + " 23:59:59";
      } else {
        this.searchInfo.preapprovalPassTimeStart = "";
        this.searchInfo.preapprovalPassTimeEnd  = "";
      }
      if (data.auditPassTime !== "" && data.auditPassTime !== null) {
        this.searchInfo.auditPassTimeStart =
          data.auditPassTime[0] + " 00:00:00";
        this.searchInfo.auditPassTimeEnd = data.auditPassTime[1] + " 23:59:59";
      } else {
        this.searchInfo.auditPassTimeStart = "";
        this.searchInfo.auditPassTimeEnd = "";
      }

      if (data.happenTime !== "" && data.happenTime !== null) {
        this.searchInfo.happenTimeStart = data.happenTime[0] + " 00:00:00";
        this.searchInfo.happenTimeEnd = data.happenTime[1] + " 23:59:59";
      } else {
        this.searchInfo.happenTimeStart = "";
        this.searchInfo.happenTimeEnd = "";
      }
      this.searchInfo.customerClaimNumber = obj.customerClaimNumber;
      this.getList();
    },
    // 记录当前列表搜索条件
    recordSearchObj() {
      this.$router.replace(
        "/kd-claimantIndex?searchObj=" +
          JSON.stringify({
            data: {
              ...this.searchInfo,
              date: this.searchInfo.preapprovalPassTimeStart
                ? [
                    this.searchInfo.preapprovalPassTimeStart.split(" ")[0],
                    this.searchInfo.preapprovalPassTimeEnd.split(" ")[0]
                  ]
                : "",
              auditPassTime: this.searchInfo.auditPassTimeStart
                ? [
                    this.searchInfo.auditPassTimeStart.split(" ")[0],
                    this.searchInfo.auditPassTimeEnd.split(" ")[0]
                  ]
                : "",


              happenTime: this.searchInfo.happenTimeStart
                ? [
                    this.searchInfo.happenTimeStart.split(" ")[0],
                    this.searchInfo.happenTimeEnd.split(" ")[0]
                  ]
                : ""
            },
            pageNum: this.page,
            pageSize: this.pageSize
          })
      );
    },
    // 查看
    toDetail(data) {
      setStorage("claimantData", data);
      this.recordSearchObj();
      this.$router.push({
        path: "/kd-claimant/detail",
        query: { claimantId: data.claimStatementId, operate: "查看详情" }
      });
    },
    // 审核
    handleAudit(data, index) {
      setStorage("claimantData", data);
      localStorage.setItem("his", 3);
      this.recordSearchObj();
      this.$router.push({
        path: "/kd-claimant/detail",
        query: {
          claimantId: data.claimStatementId,
          searchObj: JSON.stringify({
            data: {
              ...this.searchInfo
            },
            page: {
              pageNum:
                (Number(this.page) - 1) * Number(this.pageSize) + index + 1,
              pageSize: 1
            }
          }),
          enableNext: this.searchInfo.status === "3" ? "1" : "0",
          operate: "审核"
        }
      });
    },
    // 撤回
    handleRevocation(data) {
      this.$confirm(`是否确认撤回？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await formalAuditRejectRevocationApi(
            data.claimStatementId
          );
          if (res.status == "0") {
            this.$DonMessage.success("撤回成功");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        })
        .catch(() => {});
    },
    // 导出
    async handleExport() {
      // this.exportLoading = true;
      let query = {
        ...this.searchInfo
      };
      const res = await trialClimantExport(query);
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success("导出成功！")
      }
      // this.exportLoading = false;
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 获取列表
    async getList() {
      // this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await climantList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        // this.loading = false;
        this.responsibilityPartListMaxLength = 0;
        res.data.records.map(item => {
          if (
            item.responsibilityPartList &&
            item.responsibilityPartList.length >
              this.responsibilityPartListMaxLength
          ) {
            this.responsibilityPartListMaxLength =
              item.responsibilityPartList.length;
          }
        });
      }
      // this.loading = false;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filterChange(value) {
      // 国家过滤
      if (value.customerCountry) {
        if (value.customerCountry.length === 0) {
          this.searchInfo.countryId = this.searchData.countryId || [];
        } else {
          this.searchInfo.countryId = value.customerCountry;
        }
      }
      // 车型过滤
      if (value.carModel) {
        if (value.carModel.length === 0) {
          this.searchInfo.carModel = this.searchData.carModel || [];
        } else {
          this.searchInfo.carModel = value.carModel;
        }
      }
      this.getList();
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<!-- <style lang="scss" scoped>
.table-container {
  padding: 0 7px 0 23px;
}
</style> -->
